import { render, staticRenderFns } from "./PerfilChange.vue?vue&type=template&id=7fa33023&scoped=true"
import script from "./PerfilChange.vue?vue&type=script&lang=js"
export * from "./PerfilChange.vue?vue&type=script&lang=js"
import style0 from "./PerfilChange.vue?vue&type=style&index=0&id=7fa33023&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa33023",
  null
  
)

export default component.exports